import {Component} from '@angular/core';

import {AppAlertService, SubtitlesService} from "../../../core";

@Component({
    selector: 'regulations-pl',
    templateUrl: './regulations-pl.component.html',
    styleUrls: ['./regulations-pl.component.scss']
})
export class RegulationsPlComponent {
    constructor(
        public appAlert: AppAlertService,
        public subtitles: SubtitlesService,
    ) {
    }
}
